/* @flow */
import Store from 'lib/Store';
import Organization from 'entities/Organization';
import Organizations from 'collections/Organizations';

import { ActionTypes } from '../constants/OrganizationConstants';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class OrganizationStore extends Store {
  getInitialState() {
    return {
      organizations: new Organizations(),
      userOrgsLoaded: false,
    };
  }

  isLoaded(): boolean {
    return this.state.userOrgsLoaded;
  }

  getOrganization(id: Backbone$Id): ?Organization {
    return this.state.organizations.get(id);
  }

  addOrganization(organization: Organization): void {
    this.state.organizations.add(organization);
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.LOAD_ORGANIZATION:
        this.handleLoad([action.organization]);
        break;
      case ActionTypes.LOAD_USER_ORGANIZATIONS:
        this.state.userOrgsLoaded = true;
        this.handleLoad(action.organizations);
        break;
      case ActionTypes.REMOVE_ORGANIZATION:
        this.state.organizations.remove(action.orgId);
        this.emitChange();
        break;
      default:
        break;
    }
  }

  handleLoad(organizations: Organizations | Organization[]) {
    organizations.forEach(organization => this.addOrganization(organization));
    this.emitChange();
  }
}

export default new OrganizationStore();
